import { Component } from '@ecs/Component';

export class HitFlash implements Component {
  readonly type = 'HitFlash';

  constructor(
    public frames: number = 6,
    public maxFrames: number = 6
  ) {}
}
